
export class WpNcGoodCause {
    constructor(
        public id?: number,
        public goodCauseSw?: string,
        public goodCauseDesc?: string,
        public goodCauseReasonCd?: string,
        public goodCauseVerificationCd?: string,
        public goodCauseRequestDt?: any,
        public goodCauseDueDt?: any,
        public concilliationCompleteSw?: string,
        public concilliationCompletionDt?: any,
        public wpNonCompliance?: number,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-nc-good-cause.model.ts